import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import { Button, UncontrolledTooltip } from "reactstrap"

// O recurso fica sempre à vista no Dashboard; sem IA nas empresas selecionadas, aparece bloqueado.
const AcessoAnaliseIA = ({ habilitado, abrir }) => {
  const { t } = useTranslation()

  const botao = (
    <Button color="primary" disabled={ !habilitado } onClick={ () => abrir() }>
      { !habilitado && <i className="bx bxs-lock-alt me-1" /> }
      { t("dashboard.analise-ia.button") }
    </Button>
  )

  return (
    <div>
      <div className="d-flex mb-2">
        <div className="mini-stat-icon align-self-center me-3">
          <i className={ `bx bxs-magic-wand font-size-24 ${ habilitado ? "bx-burst" : "text-muted" }` }></i>
        </div>
        <p>{ t("dashboard.analise-ia.message") }</p>
      </div>
      { habilitado ? botao : (
        <>
          {/* Botão desabilitado não dispara eventos de mouse; o tooltip fica no invólucro. */}
          <span id="analise-ia-bloqueada" data-testid="analise-ia-bloqueada" className="d-inline-block" tabIndex={ 0 }>
            { botao }
          </span>
          <UncontrolledTooltip placement="top" target="analise-ia-bloqueada">
            { t("dashboard.analise-ia.bloqueada") }
          </UncontrolledTooltip>
        </>
      ) }
    </div>
  )
}

AcessoAnaliseIA.propTypes = {
  habilitado: PropTypes.bool,
  abrir: PropTypes.func.isRequired,
}

export default AcessoAnaliseIA
